/** A رمز الدخول as stored: the whole code, or "…123" for old codes that kept only 3 digits. */
export const codeText = (hint) => (!hint ? '' : String(hint).length >= 6 ? String(hint) : `…${hint}`);
